"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Column = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Column = function Column(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      gutterUnit = _ref.gutterUnit,
      stack = _ref.stack,
      split = _ref.split,
      size = _ref.size,
      flex = _ref.flex,
      align = _ref.align;
  // When stack is enabled, we don't return traces of the columns div tags
  if (stack) return _react.default.createElement(_react.Fragment, null, children); // Initial Styles: https://css-tricks.com/flexbox-truncated-text/

  var styles = {
    boxSizing: 'borderBox',
    minWidth: 0
  };
  if (gutterUnit) styles.marginLeft = "".concat(gutterUnit * 0.5, "em");
  if (gutterUnit) styles.marginRight = "".concat(gutterUnit * 0.5, "em");
  if (size && !split) styles.width = "".concat(size, "em");
  if (flex && !split) styles.flex = 1;
  if (align) styles.textAlign = align.toLowerCase();
  return _react.default.createElement("div", {
    style: styles,
    className: (0, _classnames2.default)('react-flex-column', className, (_classnames = {}, _defineProperty(_classnames, "react-flex-columns-align-".concat(align), !!align), _defineProperty(_classnames, 'react-flex-columns-flex', !!flex), _classnames))
  }, children);
};

exports.Column = Column;
Column.defaultProps = {
  split: false,
  stack: false,
  display: true
};
Column.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  gutterUnit: _propTypes.default.number,
  stack: _propTypes.default.bool,
  split: _propTypes.default.bool,
  size: _propTypes.default.number,
  flex: _propTypes.default.bool,
  align: _propTypes.default.oneOf(['left', 'right', 'center'])
};
var _default = Column;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flex-columns/build/Column.js
// module id = 353
// module chunks = 0